import { apiWithAdminToken } from '@lib/api';
import {
  communityWithAdminToken,
  couponWithAdminToken,
  merchantWithAdminToken,
  ticketWithAdminToken,
  userWithAdminToken,
  versionWithAdminToken,
} from '@lib/api/v2';

/**
 * 최고 관리자 쿠폰 발급
 * @param req
 * @returns
 */
export const postAdminCoupon = (req: any) => couponWithAdminToken.post('', req);

/**
 * 지점 키오스크 버전 정보
 * @returns
 */
export const getAdminVersion = () => versionWithAdminToken.get('');

/**
 * 커뮤니티 게시글 목록 조회
 * @param page
 * @returns
 */
export const getCommunityPost = (page: number) =>
  communityWithAdminToken.get(`/post`, { params: { page } });

/**
 * 커뮤니티 게시글 삭제
 * @param communityPostId
 * @returns
 */
export const deleteCommunityPost = (communityPostId: number) =>
  communityWithAdminToken.delete(`/post/${communityPostId}`);

/**
 * 커뮤니티 게시글 신고 목록 조회
 * @param communityPostId
 * @returns
 */
export const getCommunityPostFlag = (communityPostId: number) =>
  communityWithAdminToken.get(`/post/${communityPostId}/flag`);

/**
 * 커뮤니티 게시글 댓글 목록 조회
 * @param communityPostId
 * @param page
 * @returns
 */
export const getCommunityPostComment = (communityPostId: number, page: number) =>
  communityWithAdminToken.get(`/post/${communityPostId}/comment`, { params: { page } });

/**
 * 커뮤니티 게시글 댓글 신고 목록 조회
 * @param communityPostCommentId
 * @returns
 */
export const getCommunityPostCommentFlag = (communityPostCommentId: number) =>
  communityWithAdminToken.get(`/post/comment/${communityPostCommentId}/flag`);

/**
 * 커뮤니티 게시글 댓글 삭제
 * @param communityPostCommentId
 * @returns
 */
export const deleteCommunityPostComment = (communityPostCommentId: number) =>
  communityWithAdminToken.delete(`/post/comment/${communityPostCommentId}`);

export const getMerchantListDetail = (page: number, name: string) =>
  merchantWithAdminToken.get(`/detail`, { params: { page, name } });

export const getMerchantListDetailAll = (name: string) =>
  merchantWithAdminToken.get(`/detail/all`, { params: { name } });

export const getAdminUserList = (page: number, phoneNum: string) =>
  userWithAdminToken.get(``, { params: { page, phoneNum } });

export const getAdminMerchantUserList = (page: number, phoneNum: string) =>
  userWithAdminToken.get(`/merchant`, { params: { page, phoneNum } });

export const postAdminUserWithdrawal = (userIds: number[]) =>
  userWithAdminToken.post('/withdrawal', { userIds });

export const getAdminMerchantUserDetail = (merchantId: number, phoneNum: string) =>
  userWithAdminToken.get(`/merchant/${merchantId}/${phoneNum}`);

export const putAdminUserTicketAccess = (data?: any) =>
  userWithAdminToken.put(`/ticket/access`, data);

export const getAdminUserTicket = async (
  merchantId: number,
  start: string,
  end: string,
  page: number,
  limit: number,
  search: string,
) => userWithAdminToken.get(`/ticket/${merchantId}/${start}/${end}/${page}/${limit}/${search}`);

export const getAdminUserMemo = (merchantId: number, phoneNum: string) =>
  userWithAdminToken.get(`/memo/${merchantId}/${phoneNum}`);

export const postAdminUserMemo = (data: any) => userWithAdminToken.post(`/memo`, data);

export const deleteAdminUserMemo = (merchantId: number, id: number) =>
  userWithAdminToken.delete(`/memo/${merchantId}/${id}`);

/**
 * 회원 마일리지 내역 조회
 * @param userId
 * @param startDate
 * @param endDate
 * @param page
 * @returns
 */
export const getAdminMileageUser = (
  merchantId: number,
  userId: number,
  startDate: string,
  endDate: string,
  page: number,
) => {
  return userWithAdminToken.get(`/mileage/${userId}`, {
    params: {
      merchantId,
      startDate,
      endDate,
      page,
    },
  });
};

export const getAdminUserTicketPhoneNumber = (page: number, phoneNum: string) =>
  userWithAdminToken.get(`/ticket`, {
    params: {
      phoneNum,
      page,
    },
  });

export const getAdminUserTicketById = (ticketId: number) =>
  userWithAdminToken.get(`/ticket/${ticketId}`);

/**
 * @deprecated V2 API 사용 권장: blockTicketAdmin
 */
export const putAdminUserTicketBlock = async (data: any) =>
  apiWithAdminToken.put(`/ticket/userTicketBlock`, data);

/**
 * @deprecated V2 API 사용 권장: forceExitTicketAdmin
 */
export const putAdminTicketForceExit = async (data: any) =>
  apiWithAdminToken.put(`/ticket/ticketForceExit`, data);

/**
 * V2 이용권 차단/해제 (Admin)
 * @param data { ticketId: number; merchantId: number; block: 0 | 1 }
 */
export const blockTicketAdmin = (data: { ticketId: number; merchantId: number; block: number }) =>
  ticketWithAdminToken.patch(`/block`, data);

/**
 * V2 강제 퇴장 (Admin) - 차단 없이 퇴장만
 * @param data { ticketId: number; merchantId: number }
 */
export const forceExitTicketAdmin = (data: { ticketId: number; merchantId: number }) =>
  ticketWithAdminToken.patch(`/force-exit`, data);

export const putAdminUserTicketUpdate = async (data: any) =>
  apiWithAdminToken.put('/ticket/userTicketUpdate', data);

export const postAdminPayLog = async (info: any) => userWithAdminToken.post(`/paylog`, info);

export const getAdminUserPayLog = async (info: any) =>
  userWithAdminToken.get(`/paylog`, { params: { ...info } });

export const getAdminMerchantVAN = async (merchantId: number) =>
  merchantWithAdminToken.get('/van', { params: { merchantId } });

/**
 * 가맹점 목록 조회 (페이지네이션)
 * @returns
 */
export const getMerchantListAdmin = () => merchantWithAdminToken.get('/list');

/**
 * V2 회원 방문 로그 조회 (Admin)
 */
export interface AdminUserLogParams {
  merchantId: number;
  page: number;
  limit: number;
  start: string;
  end: string;
  search: string;
}

export interface AdminUserLogResponse {
  result: any[];
  count: number;
}

export const getAdminUserLogV2 = (params: AdminUserLogParams) =>
  userWithAdminToken.get<AdminUserLogResponse>('/log', { params });
